const menus = [
    {
        id: 1,
        name: 'Home',
         links: '/',
      
    },
    {
        id: 2,
        name: 'About Us',
        links: '/about-us',
        
    },{
        id: 3,
        name: 'Services',
        links: '/services'
      
    },
    {
        id: 4,
        name: 'Projects',
        links: '/project'
        
    },
    // {
    //     id: 5,
    //     name: 'Page',
    //     namesub: [
    //         {
    //             id: 1,
    //             sub: 'Page Testimonial',
    //             links: '/page-testimonial'
    //         },
    //         {
    //             id: 2,
    //             sub: 'Page Pricing',
    //             links: '/page-pricing'
    //         }
    //     ],
    // },
    {
        id: 6,
        name: 'Blogs',
                links: '/blog'
        
    },
    {
        id: 7,
        name: 'Contact',
          links: '/contact'

    }
]

export default menus;